function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "101.999998%",
  y2: "100.999999%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#C86DD7",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDb\xFA\xF0ir",
  transform: "translate(-1614.000000, -49.000000)",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "iconmonstr-lock-7",
  transform: "translate(1614.000000, 49.000000)"
}, React.createElement("path", {
  d: "M15.6923077,13.5384615 L15.6923077,15.5076923 L0,15.5076923 L0,13.5384615 L15.6923077,13.5384615 Z M15.6923077,17.2307692 L15.6923077,19.2 L0,19.2 L0,17.2307692 L15.6923077,17.2307692 Z M4.35897436,5.23076923 C4.35897436,3.30758974 5.92384615,1.74358974 7.84615385,1.74358974 C9.76846154,1.74358974 11.3333333,3.30758974 11.3333333,5.23076923 L11.3333333,7.84615385 L13.0769231,7.84615385 L13.0769231,5.23076923 C13.0769231,2.34251282 10.7344103,0 7.84615385,0 C4.95789744,0 2.61538462,2.34251282 2.61538462,5.23076923 L2.61538462,7.84615385 L4.35897436,7.84615385 L4.35897436,5.23076923 Z M15.6923077,11.8153846 L15.6923077,9.84615385 L0,9.84615385 L0,11.8153846 L15.6923077,11.8153846 Z",
  id: "Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/lock.b2d5892c.svg";
export { SvgComponent as ReactComponent };